<section class="partner-flowaccount-form" id="partnerFlowaccountForm-id">
  <div class="box">
    <h3 class="box-heading"
      ><span>{{ 'PARTNER_FORM.HEADING' | translate }}</span></h3
    >
    <div id="hubspot-form"></div>
  </div>
</section>
